import React, { useState } from "react";
import "./Footer.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaInstagram, FaFacebookF, FaYoutube, FaTwitter } from "react-icons/fa";
import logo from "../assets/logo.jpg";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("Please enter a valid email address");
    } else {
      toast.success("Subscribed successfully!");
      setEmail("");
    }
  };

  return (
    <footer className="footer">
      <div className="footer-animation-bg">
        <div className="orb orb1"></div>
        <div className="orb orb2"></div>
        <div className="orb orb3"></div>
      </div>

      <div className="footer-top">
        <div className="footer-brand">
          <img src={logo} style={{ backgroundColor: "white" }} alt="Brand Logo" />
          <p>
            Discover the natural beauty of our handmade herbal and organic products.
            Designed with care for your skin, hair, and wellness.
          </p>
          <div className="social-icons">
            <a href="https://www.instagram.com/roupannaturals?igsh=MWEzeGxqMWQ3aGhobA%3D%3D&utm_source=qr"><FaInstagram /></a>
            <a href="https://www.facebook.com/roupannaturals"><FaFacebookF /></a>
            <a href="https://www.youtube.com/roupannaturals"><FaYoutube /></a>
            <a href="https://twitter.com/roupannaturals"><FaTwitter /></a>
          </div>
        </div>

        <div className="footer-columns">
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li><a style={{ color: "#1a1a1a", textDecoration: "none" }} href="/">Home</a></li>
              <li><a style={{ color: "#1a1a1a", textDecoration: "none" }} href="/products">Products</a></li>
              <li><a style={{ color: "#1a1a1a", textDecoration: "none" }} href="/aboutus">About Us</a></li>
              <li><a style={{ color: "#1a1a1a", textDecoration: "none" }} href="/contact">Contact</a></li>
              <li><a style={{ color: "#1a1a1a", textDecoration: "none" }} href="/blogs">Blog</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Support</h4>
            <ul>

              <li ><a style={{ color: "#1a1a1a", textDecoration: "none" }} href="/faqs">FAQs</a></li>
              <li><a style={{ color: "#1a1a1a", textDecoration: "none" }} href="/privacy-policy">Privacy Policy</a></li>
              <li><a style={{ color: "#1a1a1a", textDecoration: "none" }} href="/refund-policy">Refund Policy</a></li>
              <li><a style={{ color: "#1a1a1a", textDecoration: "none" }} href="/terms">Terms & Conditions</a></li>
              <li><a style={{ color: "#1a1a1a", textDecoration: "none" }} href="/shipping-policy">Shipping Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="newsletter">
          <h4>Join Our Newsletter</h4>
          <form onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} RoupanNaturals. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
